import { Dispatch } from "@reduxjs/toolkit";
import { NavigateFunction } from "react-router-dom";
import { DeferredStepNavigation } from "globals/interfaces";
import { ScreenShareStatus } from "globals/enums";
import { getEndpoint } from "routes/route";
import { setDeferredStepNavigation } from "store/app.slice";

type GuardedStepNavigationArgs = {
  sourceRoute: string;
  destinationRoute: string;
  screenShareStatus: ScreenShareStatus | "";
  dispatch: Dispatch;
  navigate: NavigateFunction;
};

const isScreenShareBlocked = (screenShareStatus: ScreenShareStatus | ""): boolean => {
  return (
    screenShareStatus === ScreenShareStatus.ScreenShareStopped ||
    screenShareStatus === ScreenShareStatus.PermissionFailed ||
    screenShareStatus === ScreenShareStatus.ReInitializePermission
  );
};

const buildDeferredStepNavigation = (
  sourceRoute: string,
  destinationRoute: string
): DeferredStepNavigation => ({
  sourceRoute,
  destinationRoute,
  blocker: "screen-share"
});

const guardedStepNavigation = ({
  sourceRoute,
  destinationRoute,
  screenShareStatus,
  dispatch,
  navigate
}: GuardedStepNavigationArgs): boolean => {
  if (isScreenShareBlocked(screenShareStatus)) {
    dispatch(
      setDeferredStepNavigation({
        deferredStepNavigation: buildDeferredStepNavigation(sourceRoute, destinationRoute)
      })
    );
    return false;
  }

  navigate(getEndpoint(destinationRoute));
  return true;
};

export { buildDeferredStepNavigation, guardedStepNavigation, isScreenShareBlocked };
